import { createFileRoute } from "@tanstack/react-router";
import { LOCALE_FAQ } from "@/data/faq/locale-copy";
import { buildLocaleFaqHead } from "@/lib/faq/locale-head";
import { LocaleFaqPage } from "@/components/faq/LocaleFaqPage";

export const Route = createFileRoute("/id/faq")({
  loader: () => ({ h: buildLocaleFaqHead("id", LOCALE_FAQ.id) }),
  head: ({ loaderData }) => loaderData?.h ?? {},
  component: () => <LocaleFaqPage copy={LOCALE_FAQ.id} />,
});
